module.exports = __webpack_public_path__ + "img/extrato.146f08a7.svg";